// extracted by mini-css-extract-plugin
export default {"skeleton":"oRRVTrwXcMOFLi69Kw_r"};